<template>
  <v-container fluid fill-height id="skills" class="pa-0 ma-0 grey--text text--darken-4" style="min-height: 80vh;">
    <v-row justify="center" class="text-center my-10">
      <v-col cols="12">
        <span class="title font-weight-medium">Skills</span>
        <br /><span class="display-1 font-weight-bold">Where I am good at</span>
      </v-col>
      <v-col cols="12" class="ma-0 pb-10">
        <v-row justify="center">
          <v-col cols="2" class="ma-0 pa-0">
            <hr class="line-divider" />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="10">
        <v-row>
          <v-col cols="12" sm="6">
            <Technical />
          </v-col>
          <v-col cols="12" sm="6">
            <Professional />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div class="bottom-section" />
  </v-container>
</template>

<script>
import Technical from './components/SkillsTechnical'
import Professional from './components/SkillsProfessional'

export default {
  components: {
    Technical,
    Professional
  }
}
</script>

<style scoped>
.line-divider {
  border-radius: 10px;
  background-image: linear-gradient(160deg,rgba(0, 0, 0, 0) 0%, rgba(20, 20, 20) 88%);
  height: 5px;
  border: 0 none;
}

.hoverBtn {
  color: #BBB;
  transition: 0.5s;
  cursor: pointer;
}
.hoverBtn:hover {
  color: #777;
}
.bottom-section {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSI5MHB4IiB2aWV3Qm94PSIwIDAgMTI4MCAxNDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzFFMjUyOCI+PHBhdGggZD0iTTAgMHYxNDBoMTI4MEwwIDB6Ii8+PC9nPjwvc3ZnPg==);
  background-size: 100% 90px;
  bottom: 0;
  height: 90px;
  z-index: 1;
  transform: rotateY(180deg) rotateX(0);
}
</style>